import { Link, TextContent } from '@cloudscape-design/components';
import React from 'react';

// activeOrder.scss globally resets `ul, ol` to markerless, which also strips
// Cloudscape TextContent lists — restore the markers explicitly here.
const ulStyle = { listStyleType: 'disc', paddingLeft: 20 };
const olStyle = { listStyleType: 'decimal', paddingLeft: 20 };

/**
 * Structured how-to for printing 2"x1" labels on the Rollo, shown below the
 * PDF preview. Static content: printer setup, per-browser printing steps
 * (Firefox unsupported), and the Open PDF fallback.
 */
export default function PrintInstructions() {
  return (
    <TextContent>
      <h4>Rollo printer setup</h4>
      <ul style={ulStyle}>
        <li>
          Load a 2″ × 1″ label roll — labels facing up, guides snug against
          the roll (
          <Link external href="https://www.rollo.com/wireless/">
            loading guide
          </Link>
          ). After loading a new roll, hold the printer button until it beeps
          once so it re-learns the label size.
        </li>
        <li>
          In the print dialog, set Paper Size to 2″ × 1″.
        </li>
      </ul>

      <h4>Print with Chrome</h4>
      <ol style={olStyle}>
        <li>Click Print.</li>
        <li>
          In Chrome’s print window,
          {' '}
          <b>switch to the system dialog</b>
          {' '}
          — ⌥⌘P on Mac,
          Ctrl+Shift+P on Windows. Chrome’s own dialog ignores the label size
          and wastes several labels.
        </li>
        <li>Select the Rollo printer, set Paper Size to 2″ × 1″, and print.</li>
      </ol>

      <h4>Print with Safari</h4>
      <ol style={olStyle}>
        <li>Click Print — the label opens in a new tab.</li>
        <li>
          Press ⌘P in that tab, select the Rollo printer, set Paper Size to
          2″ × 1″, and print.
        </li>
      </ol>

      <h4>Other browsers</h4>
      <p>
        Firefox is not supported — use Chrome or Safari. If printing comes out
        wrong in any browser, click Open PDF and print or download the label
        from the PDF tab instead.
      </p>
    </TextContent>
  );
}
